import { useEffect, useRef, useState } from 'react'
import Modal from '../../components/common/Modal'

// Een opmerking bij een straat van een wervingsactie ('gesloopt, overgeslagen'),
// zodat een collega later niet voor niets teruggaat. Een venster met
// 'Opslaan' en niet opslaan per aanslag: een vrij tekstveld per aanslag naar
// Firestore verliest de staart als je wegklikt.
// AI-CONTEXT: See docs/pitfalls.md#state-per-keystroke-write-loses-the-tail

/**
 * @param {object} props
 * @param {boolean} props.open - Of het venster open is
 * @param {string} props.straat - De straatnaam, voor de kop en het veld
 * @param {string} props.beginTekst - De opmerking zoals hij nu is ('' als er geen is)
 * @param {(tekst: string) => Promise<void>} props.onSave - Slaat de tekst op; gooit bij een fout
 * @param {() => void} props.onClose - Sluit het venster
 */
const StraatOpmerkingModal = ({ open, straat, beginTekst, onSave, onClose }) => {
    const [tekst, setTekst] = useState(beginTekst)
    const [fout, setFout] = useState('')
    const [bezig, setBezig] = useState(false)
    // Stopt een tweede klik vóórdat React opnieuw rendert.
    const bezigRef = useRef(false)

    // Alleen bij openen vullen; een snapshot tijdens het typen mag het concept
    // niet overschrijven.
    // AI-CONTEXT: See docs/pitfalls.md#state-draft-wiped-by-firestore-snapshot
    useEffect(() => {
        if (!open) return
        setTekst(beginTekst)
        setFout('')
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open])

    const opslaan = async () => {
        if (bezigRef.current) return
        bezigRef.current = true
        setBezig(true)
        setFout('')
        try {
            await onSave(tekst)
            onClose()
        } catch (err) {
            setFout(err?.message || String(err))
        } finally {
            bezigRef.current = false
            setBezig(false)
        }
    }

    const kop = `Opmerking bij ${straat}`

    return (
        <Modal
            modalOpen={open}
            setModalOpen={(waarde) => { if (!waarde) onClose() }}
            confirm={opslaan}
            confirmDisabled={bezig}
            pageHeader={kop}
            content={(
                <div className='materials-modal-form'>
                    <div className='materials-modal-field'>
                        <label htmlFor='wa-straat-opmerking'><b>Opmerking</b></label>
                        <textarea
                            id='wa-straat-opmerking'
                            rows={4}
                            maxLength={500}
                            value={tekst}
                            onChange={(e) => setTekst(e.target.value)}
                            placeholder='Bijvoorbeeld: geen woningen, of overgeslagen wegens sloop'
                        />
                    </div>
                    {fout && (
                        <p className='wa-error' role='alert'>{`Opslaan is niet gelukt (${fout}). Probeer het opnieuw.`}</p>
                    )}
                </div>
            )}
        />
    )
}

export default StraatOpmerkingModal
